var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "성공사례",
            "tabActive": "전체 성공사례"
          },
          scopedSlots: _vm._u([{
            key: "titHead",
            fn: function () {
              return [_vm._v("S")];
            },
            proxy: true
          }, {
            key: "tit",
            fn: function () {
              return [_vm._v("uccess Story")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last"
  }, [_c('story-list', {
    attrs: {
      "category": 'representative'
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }